import moment from 'moment';

export function createEligibilityPatient(state) {
  return {
    firstName: state.infobox.patientFirstName,
    lastName: state.infobox.patientLastName,
    dob: moment(state.infobox.patientBirthday).format('MM/DD/YYYY'),
    address: {
      street1: state.patient.address1,
      street2: state.patient.address2,
      city: state.patient.city,
      state: state.patient.state,
      postalCode: state.patient.zip,
    },
  };
}

export default function createEligibilityData(state, coordinationTypeId, eligibilityMode) {
  const coverage = state.infobox.coverages[coordinationTypeId];

  return {
    ...createEligibilityPatient(state),
    policy: coverage.policyNumber,
    payerId: coverage.payer.payerId,
    coordinationTypeId,
    tripDate: state.eta.requestedArrivalTime,
    eligibilityMode,
    requestId: state.requests.request.id,
  };
}

export const isValidCoverage = cov => !!(cov?.payer?.payerId && cov?.policyNumber);

const isValidDate = value => !!value && moment(value).isValid();

const isPositiveNumber = value => Number.isFinite(value) && value > 0;

export function validateMultiEligibility(state) {
  const reasons = [];
  const { patientFirstName, patientLastName, patientBirthday, coverages = {} } = state.infobox;

  if (!patientFirstName || !patientFirstName.trim()) {
    reasons.push('Patient first name is required.');
  }
  if (!patientLastName || !patientLastName.trim()) {
    reasons.push('Patient last name is required.');
  }
  if (!isValidDate(patientBirthday)) {
    reasons.push('Patient date of birth is missing or invalid.');
  }
  if (!Object.values(coverages).some(isValidCoverage)) {
    reasons.push('At least one payer coverage with a policy number is required.');
  }
  if (!isPositiveNumber(state.requests.request?.id)) {
    reasons.push('Request must be saved before running the Eligibility Agent.');
  }

  return reasons;
}

export function createMultiEligibilityData(state, wandAttemptId) {
  const patient = createEligibilityPatient(state);
  const coverages = Object.keys(state.infobox.coverages)
    .filter(coordTypeId => isValidCoverage(state.infobox.coverages[coordTypeId]))
    .map(coordTypeId => {
      const cov = state.infobox.coverages[coordTypeId];
      return {
        policyNumber: cov.policyNumber,
        payerId: cov.payer.payerId,
        coordinationTypeId: parseInt(coordTypeId, 10),
      };
    });

  const payload = {
    patient: { ...patient, dob: moment(state.infobox.patientBirthday).format('YYYY-MM-DD') },
    coverages,
    eligibilityMode: 'agent',
    requestId: state.requests.request.id,
    ...(wandAttemptId ? { wandAttemptId } : {}),
  };

  // tripDate is optional in the API schema; only include it when it is a valid date
  if (isValidDate(state.eta.requestedArrivalTime)) {
    payload.tripDate = moment(state.eta.requestedArrivalTime).format('YYYY-MM-DD');
  }

  return payload;
}
